module.exports = __webpack_public_path__ + "img/motlun.9ed77c33.png";